import { Form, Row, Col } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { Input, PageWrapper, PasswordInput, Select } from "../../components";
import { useTranslation } from "react-i18next";
import { createUser, getUserDetail, updateUser } from "../../api/user";
import { Pages, Role } from '../../shared/enums'
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { RiEdit2Fill, RiAddLargeLine } from "react-icons/ri";
import Button from '../../components/common/Button';

const UserForm = ({ }) => {
    const { t } = useTranslation()
    const form = useForm()
    const navigate = useNavigate()
    const { id } = useParams()
    const [isEdit, setIsEdit] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)

    useEffect(() => {
        if (id !== "new") {
            setIsEdit(true)
            getData()
        } else {
            form.reset({ countryCode: "+60" })
        }
    }, [])

    const getData = async () => {
        const response = await getUserDetail(id)
        form.reset({ ...response, roles: response.roles[0].id, suspended: response.suspended.toString() })
    }

    const create = async (data) => {
        setBtnLoading(true)
        const response = await createUser({ ...data, roles: [Role.USER] })
        if (response.success) navigate(Pages.User)
        setBtnLoading(false)
    }

    const update = async (data) => {
        setBtnLoading(true)
        const response = await updateUser(id, { ...data, roles: [data.roles] })
        if (response.success) navigate(Pages.User)
        setBtnLoading(false)
    }

    return <PageWrapper
        headerProps={{
            title: isEdit ? "EDIT_USER" : "ADD_USER",
            rightElement: <Button
                type="submit"
                variant="primary"
                icon={isEdit ? <RiEdit2Fill /> : <RiAddLargeLine />}
                loading={btnLoading}
                onClick={() => form.handleSubmit(isEdit ? update : create)()}
            >
                {t(isEdit ? "UPDATE" : "CREATE")}
            </Button>
        }}
    >
        <FormProvider {...form}>
            <Form>
                <Input label={t("FIRST_NAME")} name={"firstName"} rules={{ required: t("FIRST_NAME_IS_REQUIRED") }} />
                <Input label={t("LAST_NAME")} name={"lastName"} rules={{ required: t("LAST_NAME_IS_REQUIRED") }} />
                <Input
                    label={t("EMAIL")}
                    name={"email"}
                    type="email"
                    placeholder={"e.g. email@example.com"}
                    rules={{
                        required: t("EMAIL_IS_REQUIRED"), pattern: {
                            value: /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/,
                            message: t("INVALID_EMAIL")
                        }
                    }} />
                {!isEdit && <PasswordInput label={t("PASSWORD")} name={"password"} rules={{ required: t("PASSWORD_IS_REQUIRED") }} />}

                <Row>
                    <Col style={{ flex: 0 }}>
                        <Select
                            label={t("COUNTRY_CODE")}
                            name={"countryCode"}
                            rules={{ required: t("COUNTRY_CODE_IS_REQUIRED") }}
                            options={[
                                { label: "+60", value: "+60" },
                            ]}
                            containerProps={{ style: { width: "120px" } }}
                        />
                    </Col>
                    <Col style={{ flex: 1 }}>
                        <Input
                            label={t("PHONE_NUMBER")}
                            name={"phoneNumber"}
                            placeholder={"e.g. 123456789"}
                            rules={{
                                required: t("PHONE_NUMBER_IS_REQUIRED"),
                                pattern: {
                                    value: /^[0-9]{8,12}$/, // A basic 10-digit number pattern (adjust as needed)
                                    message: t("INVALID_PHONE_NUMBER")
                                }
                            }}
                        />
                    </Col>
                </Row>


                <Row>
                    <Col>
                        <Select
                            label={t("GENDER")}
                            name={"gender"}
                            rules={{ required: t("GENDER_IS_REQUIRED") }}
                            options={[
                                { label: t("MALE"), value: "male" },
                                { label: t("FEMALE"), value: "female" },
                            ]}
                        />
                    </Col>

                    {isEdit && <Col >
                        <Select
                            label={t("SUSPENDED")}
                            name={"suspended"}
                            rules={{ required: t("SUSPENDED_IS_REQUIRED") }}
                            options={[
                                { label: t("YES"), value: "true" },
                                { label: t("NO"), value: "false" },
                            ]}
                        />
                    </Col>
                    }
                </Row>
            </Form>
        </FormProvider>
    </PageWrapper>
}

export default UserForm;